import { render } from "./ProteinSelector.vue?vue&type=template&id=2e16cf8d&scoped=true"
import script from "./ProteinSelector.vue?vue&type=script&lang=js"
export * from "./ProteinSelector.vue?vue&type=script&lang=js"

import "./ProteinSelector.vue?vue&type=style&index=0&id=2e16cf8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e16cf8d"]])

export default __exports__